import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormState, useField } from "react-final-form";
import { Typography } from "@material-ui/core";

const LevelInput = () => {
  const { values } = useFormState();
  const levelGroup = useField("levelGroupId");

  return (
    <>
      <ReferenceInput
        label="Level"
        source="levelId"
        reference="levels"
        filter={{
          SchoolId: values.schoolId ? parseInt(values.schoolId) : 0,
        }}
        validate={required()}
        onChange={() => {
          levelGroup.input.value !== "" && levelGroup.input.onChange("");
        }}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <Typography variant="caption">
        (Please enter the appropriate grade level based on the academic year of
        registration)
      </Typography>
    </>
  );
};

export default LevelInput;
